






















import { Component, Vue, Watch } from "vue-property-decorator";
import { validate } from "class-validator";
// @ts-ignore
import initMap from "../app/modules/googleMaps";
// @ts-ignore
import SVGTab from "../app/modules/svgTab";

import MainHeader from "../components/MainHeader.vue";
import MainFooter from "../components/MainFooter.vue";

import { ContactMessage } from "../models/contactMessage.entity";
import { elValidate } from "../models/validation/espressoValidation";
import ElInput from "../components/el-input.vue";
import ElTextarea from "../components/el-textarea.vue";

const VueScrollTo = require("vue-scrollto");

@Component({
	name: "home",
	components: {
		MainHeader,
		MainFooter,
		ElInput,
		ElTextarea,
	},
})
export default class Home extends Vue {
	public scrollToHash(hash: string) {
		this.$nextTick(() => VueScrollTo.scrollTo(hash));
	}

	private mounted() {
		if (this.$route.hash) {
			setTimeout(() => this.scrollToHash(this.$route.hash), 500);
		}

		if (document.querySelector(".main-slider__wrapper")) {
			// @ts-ignore
			$(".main-slider__wrapper").slick({
				dots: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				infinite: true,
				autoplay: true,
			});
		}

		if (document.querySelector(".publications__slider-container")) {
			// @ts-ignore
			$(".publications__slider-container").slick({
				dots: true,
				slidesToShow: 3,
				slidesToScroll: 3,
				arrows: false,
				infinite: true,
				variableWidth: true,
				touchThreshold: 10,
			});
		}

		// @ts-ignore
		if ($(".projects__map-container").length > 0) {
			const mapTab = new SVGTab();
			mapTab.init();
		}

		if (document.querySelector(".team__button")) {
			// @ts-ignore
			$(".team__button").each((i, element) => {
				// @ts-ignore
				$(element).click(() => {
					// ** get infos person
					const person = element.getAttribute("data-person");
					// @ts-ignore
					$("#person-sector").html(this.$t(`${person}.sector`));
					// @ts-ignore
					$("#person-name").html(this.$t(`${person}.name`));
					// @ts-ignore
					$("#person-office").html(this.$t(`${person}.office`));
					// @ts-ignore
					$("#person-graduation").html(this.$t(`${person}.graduation`));
					// ** get src img person
					const personImage = element.getAttribute("data-person-picture");
					// @ts-ignore
					$("#person-picture").attr("src", personImage);
				});
			});
		}

		/**
     * map init
     */
		if (document.querySelector(".main-map__map-container") !== null) {
			initMap();
		}
	}

	// ------------------------
	// Contato
	private contactErrors = [];

	message: ContactMessage = new ContactMessage();

	getContactError(property: string) {
		const propertyError = this.contactErrors.find(err => err.property === property);
		return propertyError ? propertyError.error : null;
	}

	sendMessage() {
		(async () => {
			this.contactErrors = await elValidate(this.message);

			if (this.contactErrors.length) {
				this.$swal({ icon: "error", title: this.$t("validationError") as string, text: this.$t("checkErrorsAndTryAgain") as string });
				return;
			}

			await this.message.send();

			this.message = new ContactMessage(); // reset message fields after sending

			this.$swal({ icon: "success", title: "Mensagem enviada", text: "Em breve retornaremos o seu contato." });
		})().catch((error) => {
			console.error(error);
			this.$swal({ icon: "error", title: "Erro ao enviar", text: "Tente novamente mais tarde." });
		});
	}

	@Watch("message", { deep: true })
	async validateMessage(message: ContactMessage) {
		if (this.contactErrors.length) {
			this.contactErrors = await elValidate(message);
		}
	}


	// ------------------------
	// Slick slide fix (https://github.com/akiran/react-slick/issues/848)
	startDragTime: number = Date.now();

	mouseDownHandle() {
		this.startDragTime = Date.now();
	}

	mouseUpHandle(id, event) {
		const timeDifference = Date.now() - this.startDragTime;

		if (timeDifference < 150) {
			this.$router.push(`/${this.$i18n.locale}/${this.$t("routes.publication")}/${id}`);
		}
	}
}
